import React from 'react';
import { motion } from 'framer-motion';
import { HeartCrackIcon } from 'lucide-react';
export function TheMoment() {
  return <section className="py-14 bg-cream-100 border-y border-cream-200" data-id="element-271">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="grid md:grid-cols-12 gap-12 items-center" data-id="element-273">
          <div className="md:col-span-5 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-274">
            <HeartCrackIcon className="h-12 w-12 text-terracotta-400 mb-6" strokeWidth={1} data-id="element-275" />
            <h2 className="text-3xl md:text-4xl font-display text-charcoal mb-4" data-id="element-276">
              El momento que todas conocemos
            </h2>
            <div className="w-12 h-px bg-olive-500 mb-6" data-id="element-277"></div>
          </div>

          <div className="md:col-span-7 space-y-6 text-lg text-charcoal/80 font-light" data-id="element-278">
            <p data-id="element-279">
              Hay una reunión importante mañana. Una presentación. Una
              entrevista. Un evento donde vas a conocer personas clave.
            </p>
            <p data-id="element-280">Y la noche anterior, te pruebas 7 outfits diferentes.</p>
            <p className="font-medium text-charcoal" data-id="element-281">Nada se siente bien.</p>
            <p data-id="element-282">
              No es que estés "mal" — es que ninguna de esas prendas habla el
              idioma correcto. El idioma de la mujer que tú eres hoy. La
              profesional. La emprendedora. La mujer que ha construido algo con
              esfuerzo y lo sabe.
            </p>

            <blockquote className="border-l-2 border-terracotta-400 pl-6 py-2 my-8 text-xl font-display italic text-charcoal" data-id="element-283">
              "Tu imagen debería abrir puertas antes de que tú hables. En
              cambio, te está frenando."
            </blockquote>
          </div>
        </motion.div>
      </div>
    </section>;
}